module.exports = __webpack_public_path__ + "img/ele1.9dcac833.png";